import { _QueryResource } from '@/lib/datx-jsonapi-react';
import { Country } from '@/resources/Country';

export const queryCountry = (id: string): _QueryResource<Country> => {
  return id ? [Country, id] : null;
};
